import { Routes, Route, useLocation } from 'react-router-dom';
import { Calculator } from './Calculator';
import { AdminPanel } from './AdminPanel';
import { Login } from './Login';
import { Signup } from './Signup';
import { Landing } from './Landing';
import { Pricing } from './Pricing';
import { Header } from './Header';
import { Footer } from './Footer';
import { ProtectedRoute } from './ProtectedRoute';
import { UserCalculator } from './UserCalculator';

export function AppContent() {
  const location = useLocation();
  const isCalculatorPage = location.pathname.startsWith('/') && 
    !location.pathname.startsWith('/admin') && 
    location.pathname !== '/' &&
    location.pathname !== '/demo' &&
    location.pathname !== '/signup' &&
    location.pathname !== '/pricing';

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demo" element={<Calculator />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/admin" element={<Login />} />
          <Route 
            path="/admin/panel" 
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
          <Route path="/:username" element={<UserCalculator />} />
        </Routes>
      </main>
      {!isCalculatorPage && <Footer />}
    </div>
  );
}